export interface NavItem {
  label: string;
  children?: Array<NavItem>;
  href?: string;
  key?: string;
}

export const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Bản đồ",
    href: `map`,
  },
  {
    label: "Danh mục",
    children: [
      {
        label: "Bảng giá đất",
        href: `bang-gia-dat`,
      },
      {
        label: "Khung giá đất",
        href: `khung-gia-dat`,
      },
      {
        label: "Lịch sử giá đất",
        href: `lich-su-gia-dat`,
      },
      {
        label: "Tim tuyến đường",
        href: `tim-tuyen-duong`,
      },
      {
        label: "Hệ số điêu chỉnh",
        href: `he-so-dieu-chinh`,
      },
      {
        label: "Khu vực giá đất",
        href: `khu-vuc-gia-dat`,
      },
      {
        label: "Ranh giới tuyến đường",
        href: `ranh-gioi-tuyen-duong`,
      },
    ],
  },
  {
    label: "Nhập lịch sử giá đất",
    key: 'lich-su-gia-dat',
    children: [
      {
        label: "Chuyển khung giá đất vào lịch sử",
        href: `chuyen-khung-gia-dat-vao-lich-su`,
      },
      {
        label: "Chuyển bảng giá đất vào lịch sử",
        href: `chuyen-bang-gia-dat-vao-lich-su`,
      },
      {
        label: "Chuyển hệ số điều chỉnh vào lịch sử",
        href: `chuyen-he-so-dieu-chinh-vao-lich-su`,
      },
    ],
  },
];
